import React from "react";

const MobileRestriction = () => {
    const styles = {
        container: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            backgroundColor: "#1a1a1a", // Dark background matching the app theme
            color: "#ffffff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            textAlign: "center",
            padding: "2rem",
        },
        icon: {
            fontSize: "4rem",
            marginBottom: "1.5rem",
            animation: "pulse 2s infinite",
        },
        title: {
            fontSize: "2rem",
            marginBottom: "1rem",
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            fontWeight: "bold",
            background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
        },
        message: {
            fontSize: "1.2rem",
            lineHeight: "1.6",
            maxWidth: "500px",
            color: "#cccccc",
        },
        highlight: {
            color: "#4CAF50",
            fontWeight: "bold",
        },
    };

    return (
        <div style={styles.container}>
            <div style={styles.icon}>💻</div>
            <h1 style={styles.title}>Desktop Experience Required</h1>
            <p style={styles.message}>
                For the best visualization experience, please switch to a{" "}
                <span style={styles.highlight}>desktop or laptop</span> device.
            </p>
            <p style={{ ...styles.message, fontSize: "1rem", marginTop: "1rem", opacity: 0.8 }}>
                This application relies on precise interactions and complex layouts that are optimized for larger screens.
            </p>
            <style>
                {`
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
        `}
            </style>
        </div>
    );
};

export default MobileRestriction;
